import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Button from 'components/common/Button';
import ScheduleField from 'components/fields/ScheduleField';
import IconPlus from 'components/icons/IconPlus';

const styles = () => ({
  iconPlus: {
    width: 14,
    height: 14,
    marginTop: -2,
    marginRight: 13,
  },
  buttonAddSchedule: {
    marginLeft: 20,
  },
  scheduleField: {
    '& + $scheduleField': {
      marginTop: 15,
    },
  },
});

const ScheduleFieldArray = ({ fields, customise, classes }) => (
  <Grid
    container
    direction={customise ? 'column' : 'row'}
    alignItems="flex-start"
    spacing={24}
  >
    {fields.map((field, index) => (
      <Grid
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        item
        {...!customise ? { xs: 5 } : {}}
      >
        <ScheduleField
          className={classes.scheduleField}
          name={field}
          customise={customise}
          onDelete={() => fields.remove(index)}
        />
      </Grid>
    ))}
    {customise &&
      <Grid item>
        <Button
          className={classes.buttonAddSchedule}
          color="primary"
          size="xl"
          onClick={() => fields.push({})}
        >
          <IconPlus className={classes.iconPlus} />
          Add Schedule
        </Button>
      </Grid>
    }
  </Grid>
);

ScheduleFieldArray.propTypes = {
  fields: PropTypes.shape({
    remove: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  customise: PropTypes.bool,
  classes: PropTypes.shape({
    iconPlus: PropTypes.string.isRequired,
    buttonAddSchedule: PropTypes.string.isRequired,
    scheduleField: PropTypes.string.isRequired,
  }).isRequired,
};

ScheduleFieldArray.defaultProps = {
  customise: false,
};

export default withStyles(styles)(ScheduleFieldArray);



// WEBPACK FOOTER //
// ./src/components/fields/ScheduleFieldArray.js